/**
 * Side-effect module: validates build configuration the moment it is imported.
 *
 * Imported at the very top of `src/index.tsx`, before `./App`, because the app
 * graph reads configuration at MODULE scope (`src/constants/featureFlags.ts`,
 * the `MarketContext` default value, every chain config). Without this, a bad
 * value surfaces as whichever of those happened to load first, with a vaguer
 * message and a less useful stack.
 *
 * Note this necessarily runs before `Sentry.init` — ES imports are evaluated
 * before the importing module's body — so a configuration failure appears in
 * the console and fails the build/QA run rather than being reported to Sentry.
 * That is the right trade: a misconfigured build should never reach users.
 */
import { assertFeatureFlagsValid } from "./features";
import { assertRelayerConfigValid } from "./relayers";
import { assertChainRpcConfigured } from "./chains/getters";

assertFeatureFlagsValid();
assertRelayerConfigValid();
assertChainRpcConfigured();
